function generateIdFromText(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') 
    .replace(/[^\w\-]/g, '')
    .replace(/\-+/g, '-')
    .replace(/^\-|\-$/g, '');
}

function capitalizeFirstLetter(text) {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function addIdsToH2() {
  const articleContent = document.querySelector('.article-main .prose');
  
  if (!articleContent) {
    return [];
  }

  const h2Elements = articleContent.querySelectorAll('h2');
  const h2List = [];
  
  h2Elements.forEach((h2) => {
    if (!h2.id) {
      const text = h2.textContent || h2.innerText;
      const id = generateIdFromText(text);
      
      if (id) {
        h2.id = id;
      }
    }
    
    if (h2.id) {
      h2List.push({
        id: h2.id,
        text: h2.textContent || h2.innerText
      });
    }
  });
  
  return h2List;
}

function generateTableOfContents() {
  const tocContainer = document.querySelector('.article-main__table-of-contents');
  
  if (!tocContainer) {
    return;
  }

  const h2List = addIdsToH2();
  
  if (h2List.length <= 2) {
    tocContainer.remove();
    return;
  }

  const tocList = document.querySelector('.article-main__table-of-contents-list ul');
  
  if (!tocList) {
    return;
  }

  tocList.innerHTML = '';
  
  h2List.forEach((h2) => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    
    a.href = `#${h2.id}`;
    a.textContent = capitalizeFirstLetter(h2.text);
    
    li.appendChild(a);
    tocList.appendChild(li);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', generateTableOfContents);
} else {
  generateTableOfContents();
}

